import { useEffect, useState } from 'react';
import { getToken } from 'firebase/messaging';
import { getMessagingInstance, VAPID_KEY } from '../firebase';
import saveToken from '../../services/token.service';

/**
 * Custom hook to check notification permissions on every page load/refresh
 * Shows a modal if notifications are denied and user is logged in
 */
export const useNotificationPermissionCheck = () => {
    const [showNotificationModal, setShowNotificationModal] = useState(false);

    useEffect(() => {
        const checkNotificationPermission = async () => {
            // Only check if user is logged in
            const token = localStorage.getItem('token');
            const email = localStorage.getItem('email');

            if (!token || !email) {
                // User is not logged in, skip the check
                return;
            }

            // Check if browser supports notifications
            if (!('Notification' in window)) {
                console.log('This browser does not support notifications.');
                return;
            }

            const permission = Notification.permission;
            console.log('Current notification permission status:', permission);

            if (permission === 'granted') {
                // Permission is granted, try to get/update the FCM token
                try {
                    const messaging = await getMessagingInstance();
                    if (messaging) {
                        const webToken = await getToken(messaging, { vapidKey: VAPID_KEY });

                        if (webToken) {
                            const payload = {
                                webToken,
                                email
                            };
                            await saveToken(payload);
                            console.log('FCM token saved successfully on refresh');
                        }
                    } else {
                        console.log('Messaging is not supported on this browser');
                    }
                } catch (error) {
                    console.error('Error getting FCM token on refresh:', error);
                }
            } else if (permission === 'denied') {
                // Permission is denied, show modal to inform user
                setShowNotificationModal(true);
            } else if (permission === 'default') {
                // Permission not yet requested, we can request it
                console.log('Notification permission not yet requested');
            }
        };

        checkNotificationPermission();
    }, []); // Run only once on component mount (page load/refresh)

    const closeModal = () => {
        setShowNotificationModal(false);
    };

    return {
        showNotificationModal,
        closeModal
    };
};
